"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disconnectAccountMessage = disconnectAccountMessage;
/**
 * What disconnecting an account does, in the words both clients' confirm shows
 * (BEN-141 FP-036).
 *
 * Measured, not read (2026-10-06):
 * - Every figure drops a disconnected account's transactions (`ACTIVE_ACCOUNT_TXN`
 *   in FA, the dashboard and the forecast). The transactions LIST did not (web: 72
 *   rows on a local develop stack), and FP-109's census found purchases listed
 *   twice across live and retired accounts, so the list gets the same filter
 *   (Paul, 2026-10-06). This line describes the app WITH that filter and must not
 *   ship before it.
 * - The last active account at a bank takes the whole connection with it
 *   (`BankAccountDetailView.perform_destroy`: the Item goes DISCONNECTED and
 *   Plaid's access is revoked).
 * - With no bank left, mobile's Transactions and Dashboard show "No data yet /
 *   Connect your bank" (iPhone 17).
 *
 * Mobile said the transactions "will stop appearing throughout Fomo-Fi" without
 * saying the bank goes too; web said "Your transaction history will be preserved".
 */
function disconnectAccountMessage(args) {
    const { accountName, bankName, lastAtBank, lastBank } = args;
    if (lastAtBank && lastBank) {
        return `It's your only connected account, so ${bankName} will be disconnected. Your dashboard, forecast and transactions will be empty until you connect a bank again.`;
    }
    const gone = `${accountName}'s transactions will stop appearing in Transactions and stop counting toward your dashboard, forecast and analysis.`;
    return lastAtBank
        ? `${gone} It's the only account connected at ${bankName}, so ${bankName} will be disconnected.`
        : gone;
}
//# sourceMappingURL=disconnectCopy.js.map